document.addEventListener("click", (event) => {
	if (event.target.closest(".jahre_ohne_steigerung .jahre_ohne_steigerung_span")) {
		const jahreOhneSteigerung = event.target.closest(".jahre_ohne_steigerung"),
			startmoment = moment(`${jahreOhneSteigerung.dataset.startdatum}`, "YYYY-M-D"),
			stopmoment = moment(`${jahreOhneSteigerung.dataset.stopdatum}`, "YYYY-M-D"),
			inputInaktiveJahre = jahreOhneSteigerung.querySelector(".inaktive_jahre_input"),
			divJahresliste = jahreOhneSteigerung.querySelector(".jahre_liste")

		const jahre = jahresliste(startmoment, stopmoment)

		setInaktiveJahre(jahre, inputInaktiveJahre.value)

		divJahresliste.innerHTML = ""
		jahre.forEach((jahr) => divJahresliste.append(jahr))
	}

	if (event.target.closest(".alle_jahre_aktivieren")) {
		const jahreOhneSteigerung = event.target.closest(".jahre_ohne_steigerung")

		aktiviereAlleJahre(jahreOhneSteigerung)
		updateInputInaktiveJahre(jahreOhneSteigerung)
	}

	if (event.target.closest(".alle_jahre_deaktivieren")) {
		const jahreOhneSteigerung = event.target.closest(".jahre_ohne_steigerung")

		deaktiviereAlleJahre(jahreOhneSteigerung)
		updateInputInaktiveJahre(jahreOhneSteigerung)
	}
})

const jahresliste = (startmoment, stopmoment) => {
	const jahre = new Array()

	if (startmoment.isValid() && stopmoment.isValid()) {
		const stopjahr = stopmoment.year()

		let startjahr = startmoment.year() + 1,
			zaehler = 0

		while (startjahr <= stopjahr) {
			const jahr = document.createElement("div")

			jahr.classList.add("jahr", startjahr, "cursor-pointer", "decoration-schrift_schwarz", "hover:text-white", "hover:bg-spotlight", "hover:decoration-white", "px-1", "rounded")
			jahr.innerHTML = startjahr
			jahr.addEventListener("click", toggleJahr, false)

			jahre.push(jahr)

			startjahr++
			zaehler++
			if (zaehler > 200) break
		}
	}

	return jahre
}

const setInaktiveJahre = (jahre, inaktiveJahre) => {
	jahre.forEach((jahr) => {
		if (inaktiveJahre.includes(jahr.innerHTML)) jahr.classList.add("inaktiv")
	})
}

const toggleJahr = (event) => {
	const jahr = event.target,
		jahreOhneSteigerung = jahr.closest(".jahre_ohne_steigerung")

	jahr.classList.toggle("inaktiv")
	updateInputInaktiveJahre(jahreOhneSteigerung)
}

const updateInputInaktiveJahre = (jahreOhneSteigerung) => {
	if (jahreOhneSteigerung) {
		const inputInaktiveJahre = jahreOhneSteigerung.querySelector(".inaktive_jahre_input")
		let inaktiveJahre = ""

		jahreOhneSteigerung.querySelectorAll(".jahre_liste div.inaktiv").forEach((jahr) => (inaktiveJahre += `${jahr.innerHTML},`))
		if (inaktiveJahre.length > 0) inaktiveJahre = `{ ${inaktiveJahre.slice(0, -1)} }`
		inputInaktiveJahre.value = inaktiveJahre
	}
}

const aktiviereAlleJahre = (jahreOhneSteigerung) => {
	const spanJahre = jahreOhneSteigerung.querySelectorAll("div.jahr")

	spanJahre.forEach((jahr) => jahr.classList.remove("inaktiv"))
}

const deaktiviereAlleJahre = (jahreOhneSteigerung) => {
	const spanJahre = jahreOhneSteigerung.querySelectorAll("div.jahr")

	spanJahre.forEach((jahr) => jahr.classList.add("inaktiv"))
}

const updateStartdatum = (formContainer, startmoment) => {
	if (formContainer && startmoment.isValid()) {
		const jahreOhneSteigerung = formContainer.querySelector(".jahre_ohne_steigerung")

		if (jahreOhneSteigerung) jahreOhneSteigerung.dataset.startdatum = startmoment.format("YYYY-MM-DD")
	}
}

export default { updateStartdatum }
